export const EvidenceOfCovid19VaccinationStatusMandatory = "EvidenceOfCovid19VaccinationStatusMandatory";
export const LineManagerName = "LineManagerName";
export const LineManagerEmail = "LineManagerEmail";
export const PurchaseOrderNumber = "PurchaseOrderNumber";
export const ReferredTitle = "ReferredTitle";
export const ReferredFirstName = "ReferredFirstName";
export const ReferredLastName = "ReferredLastName";
export const ReferredDob = "ReferredDob";
export const PersonalEmailAddress = "PersonalEmailAddress";
export const ConfirmPersonalEmailAddress = "ConfirmPersonalEmailAddress";
export const Postcode = "Postcode";
export const JobTitle = "JobTitle";
export const FullPartTime = "FullPartTime";
export const EmployeeId = "EmployeeId";
export const AnticipatedStartDate = "AnticipatedStartDate";
export const OrgLevel1Name = "OrgLevel1Name";
export const OrgLevel2Name = "OrgLevel2Name";
export const OrgLevel3Name = "OrgLevel3Name";
export const OrgLevel4Name = "OrgLevel4Name";
export const WorkGroups = "WorkGroups";
export const ExposureProneProcedure = "ExposureProneProcedure";
export const RegularPatientContact = "RegularPatientContact";
export const ProlongedRepetitiveMovements = "ProlongedRepetitiveMovements";
export const HeavyLoads = "HeavyLoads";
export const WorkingShifts = "WorkingShifts";
export const WorkingNights = "WorkingNights";
export const WorkingDustFumes = "WorkingDustFumes";
export const WorkingIrritants = "WorkingIrritants";
export const WorkingChemicals = "WorkingChemicals";
export const WorkingConfinedSpace = "WorkingConfinedSpace";
export const WorkingVibratingMachinery = "WorkingVibratingMachinery";
export const WorkingHeights = "WorkingHeights";
export const WorkingWithSewage = "WorkingWithSewage";
export const LoneWorking = "LoneWorking";
export const WorkingOutside = "WorkingOutside";
export const ExposureToNoiseLevels = "ExposureToNoiseLevels";
export const WorkWithVdus = "WorkWithVdus";
export const FoodHandling = "FoodHandling";
export const DrivingDuties = "DrivingDuties";
export const DrivingLGV = "DrivingLGV";
export const DrivingForkliftTrucks = "DrivingForkliftTrucks";
export const VocationalDriving = "VocationalDriving";
export const VocationalDrivingLevel = "VocationalDrivingLevel";
export const ConfirmJobFamily = "ConfirmJobFamily";
export const OtherHealthSurveillanceChecks = "OtherHealthSurveillanceChecks";
export const ContactWithLatex = "ContactWithLatex";
export const ContactWithCytotoxics = "ContactWithCytotoxics";
export const WorkingWithChildren = "WorkingWithChildren";
export const ExposureToChallengingOrAggressiveBehaviour = "ExposureToChallengingOrAggressiveBehaviour";
export const Covid19RiskAssessment = "Covid19RiskAssessment";
